import angular from 'angular';

class modalMessageCtrl {
  /* @ngInject */
  constructor() {}
  close() {
    this.modalInstance.dismiss(this.data);
  }

  $onInit() {
    this.modalTitle = angular.copy(this.resolve.modalTitle);
    this.message = angular.copy(this.resolve.message);
  }
}

angular.module('app.principal').component('modalMessage', {
  templateUrl: require('./modal-message.html'),
  controller: modalMessageCtrl,
  bindings: {
    modalInstance: '<',
    resolve: '<'
  }
});
